import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface YoutubeProps {
  band: Band
}

export const Youtube: React.FC<YoutubeProps> = ({ band }) => {
  const fieldData = {
    field: "youtube_url",
    serviceClass: "YoutubeService",
    name: "youtube",
    label: "Your Youtube URL",
    placeholder: "Youtube URL",
    notes:
      "Link your profile to your YouTube page. Make sure to post your new videos (Create A Post), so everyone sees your new stuff.",
    required: false,
  }

  return (
    <>
      <EditBandFormField type="text" fieldData={fieldData} />
    </>
  )
}
